import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ShopRoutingModule } from './shop-routing.module';
import { EditorModule } from '@tinymce/tinymce-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { HomePageComponent } from './shop-components/home-page/home-page.component';
import { ShopHeaderComponent } from './shop-components/shop-header/shop-header.component';
import { ShopSidebarComponent } from './shop-components/shop-sidebar/shop-sidebar.component';
import { ProductPageComponent } from './shop-components/product-page/product-page.component';
import { ShopPaginationComponent } from './shop-components/shop-pagination/shop-pagination.component';
import { NgxImgZoomModule } from 'ngx-img-zoom';
import { OrderConfirmComponent } from './shop-components/order-confirm/order-confirm.component';
import { CheckoutComponent } from './shop-components/checkout/checkout.component';
import { PaymentStatusComponent } from './shop-components/payment-status/payment-status.component';
import { PaymentCancelComponent } from './shop-components/payment-cancel/payment-cancel.component';
import { RegisterComponent } from './shop-components/customer-register/register/register.component';
import { ConfirmAccountComponent } from './shop-components/confirm-account/confirm-account/confirm-account.component';
import { ResendConformationComponent } from './shop-components/customer-register/resend-conformation/resend-conformation.component';
import { AddProductWarrantyServiceComponent } from './shop-components/add-product-warranty-service/add-product-warranty-service.component';
import { ProductWarrantyDescriptionComponent } from './shop-components/product-warranty-description/product-warranty-description.component';
import { CustomerDownloadInvoiceComponent } from './shop-components/customer-download-invoice/customer-download-invoice.component';
import { RequestQuoteComponent } from './shop-components/request-quote/request-quote.component';
import { RelatedProductListComponent } from './shop-components/related-product-list/related-product-list.component';
import { ProductNameComponent } from './shop-components/product-name/product-name.component';
import { RelatedProductPaginationComponent } from './shop-components/related-product-pagination/related-product-pagination.component';
import { ReviewComponent } from './shop-components/review-management/review.component';
import { SeoHeaderComponent } from './shop-components/seoHeader/seo-header.component';
import { SeoTitleComponent } from './shop-components/seoHeader/seo-title/seo-title.component';
import { SeoDescriptionComponent } from './shop-components/seoHeader/seo-description/seo-description.component';
import { SeoKeywordComponent } from './shop-components/seoHeader/seo-keyword/seo-keyword.component';
import { CustomerReviewFormComponent } from './shop-components/customer-review-form/customer-review-form.component';
import { ProductComponent } from './shop-components/product-type/product.component';
import { ReviewMessageComponent } from './shop-components/review-message/review-message.component';
/*Set the module for PACS project */
@NgModule({
  declarations: [HomePageComponent, ShopSidebarComponent,
    ProductPageComponent, ShopPaginationComponent, ShopHeaderComponent, 
    OrderConfirmComponent, CheckoutComponent, PaymentStatusComponent, 
    PaymentCancelComponent, RegisterComponent, ConfirmAccountComponent, 
    ResendConformationComponent, AddProductWarrantyServiceComponent, 
    ProductWarrantyDescriptionComponent, CustomerDownloadInvoiceComponent, 
    RequestQuoteComponent, RelatedProductListComponent, ProductNameComponent, 
    RelatedProductPaginationComponent, ReviewComponent, SeoHeaderComponent, 
    SeoTitleComponent, SeoDescriptionComponent, SeoKeywordComponent, CustomerReviewFormComponent, ProductComponent, ReviewMessageComponent,
    ],
  imports: [
    CommonModule,
    ShopRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    EditorModule,
    NgSelectModule,
    NgxImgZoomModule
  ],
  exports: [
  ],
  entryComponents:[ CheckoutComponent, AddProductWarrantyServiceComponent, ProductWarrantyDescriptionComponent, ProductNameComponent, ReviewMessageComponent ]
})
export class ShopModule { }